import { CUSTOM_ELEMENTS_SCHEMA, Component, Input, inject } from '@angular/core';
import { IUserProfile } from 'app/interfaces';
import { PopupService } from '../popup/popup.service';
import { UserSessionsService } from 'app/shared/services/user-sessions/user-sessions.service';
import { PopupComponent } from '../popup/popup.component';

@Component({
  selector: 'app-renewal-popup',
  templateUrl: './renewal-popup.component.html',
  styleUrls: ['./renewal-popup.component.scss'],
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [PopupComponent],
})
export class RenewalPopupComponent {
  @Input() userProfile: IUserProfile | null = null;
  private popupService: PopupService = inject(PopupService);
  private userSessionService: UserSessionsService = inject(UserSessionsService);
  constructor() {
    this.popupService.open('renewalPopup');
  }

  onSubmit(action: boolean) {
    this.userSessionService.exemptionRenewals(action, this.userProfile);
  }
}
